import template from './contracts.html';
import controller from './contracts.controller';

let contractsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default contractsComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/contracts/contracts.component.js